<template>
  <div
    class="enter-cabinet__nav"
    :class="{ center: chooseEnter !== 'email' || activeTab !== 'enter' }"
  >
    <a
      v-if="activeTab === 'enter' && chooseEnter === 'email'"
      href="javascript:void(0)"
      class="cabinet-main-btn__link"
      @click="openForgotPasswordForm"
    >
      {{ authData.messages.forgot_password }}
    </a>
    <span v-if="activeTab === 'registration'" class="enter__button" @click="changeTab('enter')"
      >{{ authData.messages.login_cabinet }}
    </span>
    <span v-else-if="activeTab === 'enter'" @click="changeTab('registration')"
      >{{ authData.messages.register_m }}
    </span>
  </div>
</template>
<!--:class="{'enter__active': activeTab === 'enter'}"-->
<!--:class="{'enter__active': activeTab === 'registration'}"-->

<script>
import { mapState } from 'vuex';
import useModal from '@use/useModal/useModal';
import ForgotPassword from '@components/Cabinet/EnterCabinet/ForgotPassword/ForgotPassword.vue';

export default {
  name: 'EnterCabinetNav',
  data() {
    return {
      modal: useModal(),
    };
  },
  computed: {
    ...mapState({
      authData: ({ personal }) => personal.data,
      activeTab: ({ personal }) => personal.data.activeTab,
      chooseEnter: ({ personal }) => personal.data.chooseEnter,
    }),
  },
  methods: {
    changeTab(name) {
      this.$store.commit('personal/changeActiveTab', name);
      this.$store.commit('personal/clearState');
    },
    openForgotPasswordForm() {
      // this.$DefModal.hide();
      this.modal.show(
        ForgotPassword,
        {},
        {
          width: '440px',
        }
      );
    },
  },
  updates() {},
};
</script>

<style lang="scss" scoped>
.enter-cabinet {
  &__nav {
    display: flex;
    height: 40px;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    color: #618eaf;
    text-decoration: underline;
    & > span {
      align-self: center;
      //color: var(--color-red);
      pointer-events: auto;
      font-size: rem(14);
      text-transform: uppercase;
      &:hover {
        cursor: pointer;
      }
    }
    &.center {
      justify-content: center;
    }
  }
}
</style>
